import type { TIrrigationDeviceStatus } from 'App/Map/types'
import { getTooltipBody } from './getTooltipBody'

export const getTooltipForActivityIntervals = ({
  currentTimeStamp,
  appliedWater,
  showPressure,
  pressureValue,
  status,
  periodDurationText,
  periodFromDateText,
  periodToDateText,
}: {
  currentTimeStamp: string
  appliedWater: string | null
  showPressure: boolean
  pressureValue: string
  status: TIrrigationDeviceStatus
  periodDurationText: string
  periodFromDateText: string
  periodToDateText: string
}) =>
  `<div style="font-weight: bold; padding-bottom: 4px;">${showPressure ? currentTimeStamp : ''}</div>
   ${getTooltipBody({
     appliedWater,
     showPressure,
     pressureValue,
     status,
     periodDurationText,
     periodFromDateText,
     periodToDateText,
   })}
  `
